import React, { Component } from "react";
import { StyledAdvancedSectionHeader } from "../styled/details/styleAdvancedPanel";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { Box, Divider, Flex, Icon, Text } from "@chakra-ui/react";
import { toPascalCase } from "../../_utils/common";
import * as ReactIcon from "react-icons/fa";

class TldrCollpasibleSectionSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: props.collapse,
    };
  }

  toggleCollpase = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.collapse !== this.props.collapse) {
      this.setState({
        collapse: this.props.collapse,
      });
    }
  }

  render() {
    const {
      title,
      subtitle,
      className,
      wrapperClassName,
      description,
      icon,
      iconColor,
    } = this.props;
    const { collapse } = this.state;
    return (
      <Box className={`${wrapperClassName}`} mb={2}>
        <StyledAdvancedSectionHeader
          className={className}
          onClick={() => {
            if (this.props.onClick) {
              this.props.onClick();
            } else {
              this.toggleCollpase();
            }
          }}
        >
          <Flex direction="column" width="90%">
            <Text fontSize="1rem">
              {icon && (
                <Icon
                  as={ReactIcon[`Fa${toPascalCase(icon)}`]}
                  color={iconColor}
                />
              )}
              {title}
            </Text>
            {subtitle && <div className="subtitle">{subtitle}</div>}
          </Flex>

          <Box m={1}>{collapse ? <FaAngleDown /> : <FaAngleUp />}</Box>
        </StyledAdvancedSectionHeader>
        {!collapse && (
          <>
            {description && (
              <Text my={1} fontSize="0.875rem" color="gray.300">
                {description}
              </Text>
            )}
            <Divider my={2} />
            {this.props.children}
          </>
        )}
      </Box>
    );
  }
}

TldrCollpasibleSectionSettings.defaultProps = {
  className: "",
};

TldrCollpasibleSectionSettings.propTypes = {};

export default TldrCollpasibleSectionSettings;
